import { Params, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useGetCustomerById } from '@utils/api/back-office/customer-bo/use-get-customer-bo.tsx';
import CustomerBoActivity from '@components/back-office/customer/customer-bo-activity.tsx';
import Breadcrumb from '@components/atoms/ui-kit/breadcrumb.tsx';
import { PATHS } from '../../../router/paths';

export default function CustomerBoActivityPage() {
  const { customerId } = useParams<Params>();
  const { t } = useTranslation();
  const { data, isError } = useGetCustomerById(Number(customerId));

  const customerName = data?.result?.name || t('customer');

  const breadcrumbItems = [
    { label: t('customers'), path: PATHS().CUSTOMERS },
    { label: customerName, path: PATHS(customerId || '').CUSTOMER_CONTENT },
    { label: t('activity') }
  ];

  if (isError) {
    return (
      <div className="bg-app flex-1 flex items-center justify-center">
        <p className="text-sm">{t('error-loading-customer')}</p>
      </div>
    );
  }

  return (
    <div className="bg-app flex-1">
      <div className="my-2 px-4 py-2">
        <Breadcrumb items={breadcrumbItems} />
        <CustomerBoActivity />
      </div>
    </div>
  );
}
